import {
  GET_USER_PERMISSIONS,
  ADD_PM_IN_DIV,
  REV_PM_FROM_DIV,
  PROJECTS_TABLE_ERROR,
  CLEAR_PROJECTS_TABLE_ERROR,
  LOADING_ACTION,
} from 'actions/Types';
import {
  RESET_PROJECT_FILTERS,
  SET_PROJECT_FILTER,
  UPDATE_PROJECT_OPTIMISTIC,
  CREATE_PROJECT_OPTIMISTIC,
  ROLLBACK_PROJECT_UPDATE,
} from '../actions/Types';

const filtersObj = {
  projectName: [],
  managerName: [],
  division: [],
  status: [],
  selectedTeam: [],
  selectedSaleTeamMember: [],
  selectedContract: [],
  selectedCountry: [],
  searchByBillingChannel: [],
  clientName: [],
  engagement: [],
  leadSource: []
}


const initialState = {
  allDivisions: [],
  projects: [],
  allProjectsNames: [],
  available_employees: [],
  billing_employees: [],
  roles: [],
  project_managers: [],
  all_project_managers: [],
  user_detail: [],
  userPermissions: {},
  csm_employees: [],
  non_tech_employees: [],
  current_user: '',
  addPmInDiv: [],
  remPmFromDiv: [],
  showLoader: false,
  projectsWithEmployees: [],
  projectTimeline: [],
  slackChannels: [],
  getProjectDetails: {},
  updateProjectStatus: {},
  onboardingSuccess: '',
  filters: filtersObj,
  QBCustomers: [],
  monthBasedCSVProjectsData: {},
};

const errorState = {
  isError: false,
  response: {},
};



const divisionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DIVISIONS':
      return {
        ...state,
        allDivisions: action.payload,
      };
    case 'GET_NAMES_PROJECTS':
      return {
        ...state,
        allProjectsNames: action.payload,
      };
    case 'GET_PROJECTS':
      return {
        ...state,
        projects: action.payload.projects,
        available_employees: action.payload.available_employees ? action.payload.available_employees : [],
        non_tech_employees: action.payload.non_tech_employees ? action.payload.non_tech_employees : [],
        roles: action.payload.roles,
        project_managers: action.payload?.project_managers ? action.payload?.project_managers : [],
        sales_teams: action.payload?.sales_teams ? action.payload.sales_teams : [],
        csm_employees: action.payload.csm_employees ? action.payload.csm_employees : [],
        allDivisions: action.payload.divisions ? action.payload.divisions : [],
        billing_employees: action.payload.billing_employees || [],
        pagination_info: {totalCount: action.payload.totalCount, currentPage: action.payload.currentPage, totalPages: action.payload.totalPages, pageSize: action.payload.pageSize },
        insights: {totalCount: action.payload.totalCount, closed: action.payload.closedCount, paused: action.payload.pausedCount, presale: action.payload.presaleCount, active: action.payload?.activeCount}
      };
    case CREATE_PROJECT_OPTIMISTIC:
      return {
        ...state,
        projects: [action.payload, ...state.projects],
      };
    case UPDATE_PROJECT_OPTIMISTIC:
      return {
        ...state,
        projects: state.projects.map((project) => {
          if (project.id === action.payload.projectId) {
            const updates = { ...action.payload.updates };

            // If updating projectManagerId, also update the Employees array
            if (updates.projectManagerId !== undefined) {
              const pmRole = state.roles?.find((role) => role.name?.toLowerCase() === 'project manager');
              const currentEmployees = project.Employees || [];

              // Remove old PM from Employees array
              const employeesWithoutPM = currentEmployees.filter((emp) => emp.EmployeeProject?.role_id !== pmRole?.id);

              // Add new PM to Employees array if value is not null/N/A
              if (updates.projectManagerId && updates.projectManagerId !== 'N/A') {
                const pmEmployee = state.project_managers?.find((pm) => pm.id === updates.projectManagerId);
                if (pmEmployee) {
                  employeesWithoutPM.push({
                    ...pmEmployee,
                    roleName: 'Project Manager',
                    EmployeeProject: {
                      role_id: pmRole?.id,
                    },
                  });
                }
              }

              updates.Employees = employeesWithoutPM;
            }

            return { ...project, ...updates };
          }
          return project;
        }),
      };
    case ROLLBACK_PROJECT_UPDATE:
      return {
        ...state,
        projects: action.payload.previousProjects,
      };
    case 'ONBOARDING_SUCCESS':
      return {
        ...state,
        onboardingSuccess: action.payload,
      };
    case 'SET_PROJECT_WITH_EMPLOYEES':
      return { ...state, projectsWithEmployees: action.payload };
    case 'GET_SLACK_CHANNELS':
      return { ...state, slackChannels: action.payload.data || [] };
    case GET_USER_PERMISSIONS:
      return { ...state, userPermissions: action.payload };
    case 'TEAMS_FAIL':
      return {
        ...state,
        allDivisions: [],
      };
    case 'PROJECTS_FAIL':
      return {
        ...state,
        projects: [],
        available_employees: [],
        roles: [],
      };
    case 'GET_USER_DETAIL':
      return {
        ...state,
        user_detail: action.payload.Projects,
        current_user: action.payload.department,
        // projects: action.userProjects,
        project_managers: action.projectManagers,
        roles: action.userRoles,
        available_employees: action.availableEmployees,
        non_tech_employees: action.nonTechEmployees,
        sales_teams: action.sales_teams ? action.sales_teams : [],
      };
    case LOADING_ACTION:
      return { ...state, showLoader: action.payload };
    case ADD_PM_IN_DIV:
      return {
        ...state,
        user_detail: action.payload.Projects,
        current_user: action.payload.department,
        projects: action.userProjects,
        roles: action.userRoles,
        available_employees: action.availableEmployees,
        addPmInDiv: action.payload,
      };
    case REV_PM_FROM_DIV:
      return {
        ...state,
        user_detail: action.payload.Projects,
        current_user: action.payload.department,
        projects: action.userProjects,
        roles: action.userRoles,
        available_employees: action.availableEmployees,
        remPmFromDiv: action.payload,
      };
    case 'GET_ALL_PM':
      return {
        all_project_managers: action.payload,
      };
    case 'SET_PROJECT_TIMELINE':
      return {
        ...state,
        projectTimeline: action.payload[0]?.data,
      };
    case 'SET_PROJECT_DETAIL':
      return {
        ...state,
        getProjectDetails: action.payload.project,
      };
    case 'UPDATE_PROJECT_STATUS':
      return {
        ...state,
        updateProjectStatus: action.payload,
      }
    case SET_PROJECT_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.name]: action.payload.value
            ? action.payload.value.map((item) => ({
                ...item,
                name: action.payload.name,
              }))
            : [],
        },
      };
    case RESET_PROJECT_FILTERS:
      return {
        ...state,
        filters: filtersObj,
      };
    case 'GET_QB_CUSTOMERS':
      return { ...state, QBCustomers: action.payload.data || [] };
    case 'GET_MONTH_BASED_CSV_PROJECTS_DATA':
      return { ...state, monthBasedCSVProjectsData: action.payload };
    default:
      return { ...state };
  }
};

const projectsErrorReducer = (state = errorState, action) => {
  switch (action.type) {
    case PROJECTS_TABLE_ERROR:
      state = {
        isError: true,
        response: action.payload,
      };
      return state;
    case CLEAR_PROJECTS_TABLE_ERROR:
      state = {
        isError: false,
        response: {},
      };
      return state;
    default:
      return state;
  }
};


export { divisionsReducer, projectsErrorReducer };
